import { mapStageRenderTargets } from 'modules/manager/domain/data-mappers';
import { STAGE_RENDER_TARGETS_QUERY, type StageRenderTargetsGql } from 'modules/manager/domain/graphql/stage-render-targets';
import type { StageRenderTarget } from 'modules/manager/domain/interfaces';
import { baseApi } from 'shared/api/base-api';

/**
 * Сколько картинок турнирной таблицы запрашивать у рендера: бэкенд на один
 * `POST /api/render-template` отдаёт один PNG, поэтому групповой этап приходится
 * рендерить отдельным запросом на каждую группу (`groupId`).
 */
const stageRenderTargetsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    stageRenderTargets: build.query<StageRenderTarget[], number>({
      query: (stageId) => ({
        query: STAGE_RENDER_TARGETS_QUERY,
        variables: { stageId },
      }),
      transformResponse: (raw: { stage: StageRenderTargetsGql }) => mapStageRenderTargets(raw.stage),
    }),
  }),
  overrideExisting: false,
});

export const { useLazyStageRenderTargetsQuery } = stageRenderTargetsApi;

export default stageRenderTargetsApi;
